import { render } from "./ColorPickerModal.vue?vue&type=template&id=573241e0&scoped=true"
import script from "./ColorPickerModal.vue?vue&type=script&lang=js"
export * from "./ColorPickerModal.vue?vue&type=script&lang=js"

import "./ColorPickerModal.vue?vue&type=style&index=0&id=573241e0&lang=scss"
import "./ColorPickerModal.vue?vue&type=style&index=1&id=573241e0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-573241e0"]])

export default __exports__